import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { QuestItemService } from '../quest-item.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'qst-quest-items',
  templateUrl: './quest-items.component.html',
  styleUrls: ['./quest-items.component.scss']
})
export class QuestItemsComponent implements OnInit {
  @Input() sectionId: number;
  @Output() scoreChanged = new EventEmitter<number>();

  title: string;
  items: Object;

  fileToUpload: File = null;

  constructor(private questItemService: QuestItemService,
    private activatedRoute: ActivatedRoute) { 
  }

  ngOnInit(): void {
    var section: Object;
    
    section = this.questItemService.get(this.sectionId);
    console.log(section);

    this.title = section['title'];
    console.log(this.title);

    this.items = section['quests'];
  }

  faCheckCircle = faCheckCircle;

  completeQuestItem(qiForm) {
    //console.log(qiForm);
    var newScore: number;
    qiForm.fileToUpload = this.fileToUpload;

    console.log("QuestItemComponent.completeQuestItem");
    console.log(qiForm);

    newScore = this.questItemService.completeQuestItem(qiForm);
    //console.log("QuestItem.onSubmit: newScore = " + newScore);
    this.scoreChanged.emit(newScore);
  }

  unCompleteQuestItem(id) {
    console.log("QuestItemService.unCompleteQuestItem: " + id);
    var newScore: number;

    newScore = this.questItemService.unCompleteQuestItem(id);
    this.fileToUpload = null;
    this.questItemService.setFileToUpload(id, null);
    this.scoreChanged.emit(newScore);

  }

  changeFileInput( id: number, files: FileList ) {
    console.log("QuestItemsComponent.changeFileInput()");
    this.fileToUpload = files.item(0);
    this.questItemService.setFileToUpload(id, files.item(0));

    console.log(this.fileToUpload);
  }

  fileInputSet(id: number) {
    var result: File;

    result = this.questItemService.getFileToUpload(id);

    return (result === null);
  }

}


/*

[{"title":"Section 1 Title","quests":[{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0}]},{"title":"Section 2 Title","quests":[{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0}]},{"title":"Section 3 Title","quests":[{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},{"id":0,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}}]}]

*/
